import JsonApiObject from '@/_models/JsonApi'

export default class ProjectUserContractorRoleAssignmentModel extends JsonApiObject {
    constructor(data: any, included?: any) {
        super(data, included)
    }

    get role() {
        return this._relationships['role']
    }
}
